import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { breakpoints, useWindowWidth } from '@awaze/design-system.utils.react';
import { Text } from '@awaze/design-system.components.text';
import { StyledBaseGrid, StyledBaseGridItem, StyledButton, StyledDivider, StyledPagingWrapperPopularDiv, } from './destination-list.styles';
import { buttonProtoProps, selectLocation } from './destination-list.utils';
import { useSearchFormContext } from '../search-form.context';
import { DestinationListPagination } from './destination-list-pagination';
export const DestinationListPopular = ({ destinations, pageSize = 16, translations, onDestinationSelected, closeDestinationsList, }) => {
    const { formHooks } = useSearchFormContext();
    const width = useWindowWidth();
    const isWideLayout = width >= breakpoints[0];
    const [slicePage, setSlicePage] = useState({ from: 0, to: pageSize });
    const { from, to } = slicePage;
    const destinationsLength = destinations.length;
    const getPage = (pageIndex) => {
        const { from, to } = slicePage;
        setSlicePage({
            from: from + pageSize * pageIndex,
            to: to + pageSize * pageIndex,
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx(StyledDivider, { margin: 20 }), _jsxs(StyledPagingWrapperPopularDiv, { children: [_jsx(Text, { className: "secondary-title", sizes: 300, type: "mid", children: translations.popularDestinations }), isWideLayout && destinationsLength > pageSize && (_jsx(DestinationListPagination, { pageSize: pageSize, from: from, to: to, destinationsLength: destinationsLength, getPage: getPage }))] }), _jsx(StyledBaseGrid, { flush: true, align: "center", children: destinations
                    ?.slice(from, isWideLayout ? to : destinationsLength)
                    .map((location) => (_jsx(StyledBaseGridItem, { ...(isWideLayout && {
                        columns: [12, 6, 3],
                    }), children: _jsx(StyledButton, { "data-testid": "destination-list-popular-button", ...buttonProtoProps, text: _jsx(Text, { sizes: 200, type: "mid", children: location.name }), icon: "", onClick: () => {
                            selectLocation(location, formHooks);
                            closeDestinationsList?.();
                            onDestinationSelected?.();
                        }, colourScheme: "brand-primary" }) }, location.name))) })] }));
};
//# sourceMappingURL=destination-list-popular.js.map